// src/utils/jobStorage.js
// Local storage fallback helper for jobs and candidate applications when PHP backend is unreachable

const INITIAL_JOBS = [
  {
    id: 1,
    title: "Senior MEP Engineer",
    qualification: "B.E. / B.Tech in Mechanical or Electrical Engineering",
    experience: "5+ Years",
    positions: 2,
    description: "Lead MEP design projects, coordinate HVAC, electrical, and plumbing layouts with architectural teams."
  },
  {
    id: 2,
    title: "HVAC Design Specialist",
    qualification: "Diploma / Degree in Mechanical Engineering",
    experience: "3+ Years",
    positions: 3,
    description: "Design heat load calculations, duct layouts, and VRF/chiller system schematics."
  },
  {
    id: 3,
    title: "Plumbing & Fire Fighting Engineer",
    qualification: "B.E. Mechanical / Civil",
    experience: "2+ Years",
    positions: 2,
    description: "Prepare NBC-compliant hydraulic calculations, water supply, drainage, and sprinkler system layouts."
  }
];

const STORAGE_KEY = "skyline_mep_local_jobs";
const APPS_STORAGE_KEY = "skyline_mep_local_applications";

export function getLocalJobs() {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    if (data) {
      const parsed = JSON.parse(data);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed;
      }
    }
  } catch {
    // Ignore error
  }
  return INITIAL_JOBS;
}

export function saveLocalJob(jobData) {
  const current = getLocalJobs();
  let updated;
  if (jobData.id) {
    updated = current.map(j => (j.id === jobData.id ? { ...j, ...jobData } : j));
  } else {
    const newJob = {
      ...jobData,
      id: Date.now()
    };
    updated = [newJob, ...current];
  }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // Ignore error
  }
  return updated;
}

export function deleteLocalJob(id) {
  const current = getLocalJobs();
  const updated = current.filter(j => j.id !== id);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // Ignore error
  }
  return updated;
}

export function getLocalApplications() {
  try {
    const data = localStorage.getItem(APPS_STORAGE_KEY);
    if (data) {
      const parsed = JSON.parse(data);
      if (Array.isArray(parsed)) {
        return parsed;
      }
    }
  } catch {
    // Ignore error
  }
  return [];
}

export function saveLocalApplication(appData) {
  const current = getLocalApplications();
  const newApp = {
    id: Date.now(),
    name: appData.name || "Candidate",
    email: appData.email || "",
    birthdate: appData.birthdate || "",
    position: appData.position || "MEP Engineer",
    workex: appData.workex || "",
    message: appData.message || "",
    file_url: appData.file_url || null,
    file_name: appData.file_name || "Resume.pdf",
    applied_at: new Date().toLocaleString()
  };
  const updated = [newApp, ...current];
  try {
    localStorage.setItem(APPS_STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // Ignore error
  }
  return updated;
}
